import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import { purple, green, red, blue, indigo, teal } from '@material-ui/core/colors';
import CustomButton from './CustomButton';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function GuideEvent() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className="wraper">
        {/* <div className="p-3">
          <Typography className="text-danger font-weight-bold line180 my-2" variant="h6" component="h2">
            ■デーリー東北チケットセンター　本社３階読者局に移動
          </Typography>
          <Typography className="text-danger font-weight-bold line180 my-2" variant="body1" component="h2">
          　デーリー東北新聞社は４月１日より、これまで本社１階で対応していたデーリー東北チケットセンターを、３階の読者局読者コミュニケーション部に移動します。営業時間は午前１０時～午後４時。土日・祝日、お盆、年末年始は休み。問い合わせはデーリー東北チケットセンター＝電話0178（73）2882＝へ。
          </Typography>
        </div> */}

        {/* <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            チケット情報
          </Typography>
          <dl>
            <dt>座席が選べます</dt>
            <dd>
              デーリー東北チケットセンターは対面販売になりますので、座席を直接ご確認の上、ご購入できます。
            </dd>
            <dt>会員向け先行販売も</dt>
            <dd>
              デーリー東北主催イベントは、デリオンくらぶ会員を対象とした先行販売がございます。（入会金・年会費無料）
            </dd>
            <dt>販売店受取も可能</dt>
            <dd>
              お電話でご購入の方は、「デーリー東北」配達エリアの販売店で、チケットの受け取りが可能です。<br />
            </dd>
          </dl>
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="/ticket" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  詳　細
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box> */}

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            その他の主な事業一覧
          </Typography>
          <Grid className="p-3" spacing={0} container direction="row" justify="center">
            <Grid item xs={12} md={4} className="font-weight-bold"><ArrowRightIcon />１月のイベント</Grid>
            <Grid item xs={12} md={8}>
              入学おめでとう大会
            </Grid>
          </Grid>
          <Divider />
          <Grid className="p-3" spacing={0} container direction="row" justify="center">
            <Grid item xs={12} md={4} className="font-weight-bold"><ArrowRightIcon />２月のイベント</Grid>
            <Grid item xs={12} md={8}>
              こども絵画コンクール（審査・表彰式）<br/>
              北奥羽学生俳句大会（表彰式）
            </Grid>
          </Grid>
          <Divider />
          <Grid className="p-3" spacing={0} container direction="row" justify="center">
            <Grid item xs={12} md={4} className="font-weight-bold"><ArrowRightIcon />３月のイベント</Grid>
            <Grid item xs={12} md={8}>
              スプリング・ミュージック・フェスタ
            </Grid>
          </Grid>
          <Divider />
          <Grid className="p-3" spacing={0} container direction="row" justify="center">
            <Grid item xs={12} md={4} className="font-weight-bold"><ArrowRightIcon />４月のイベント</Grid>
            <Grid item xs={12} md={8}>
              北奥羽市町村対抗ボウリング選手権
            </Grid>
          </Grid>
          <Divider />
          <Grid className="p-3" spacing={0} container direction="row" justify="center">
            <Grid item xs={12} md={4} className="font-weight-bold"><ArrowRightIcon />５月のイベント</Grid>
            <Grid item xs={12} md={8}>
              八戸うみねこマラソン全国大会<br/>
            大学進学説明会
            </Grid>
          </Grid>
          <Divider />
          <Grid className="p-3" spacing={0} container direction="row" justify="center">
            <Grid item xs={12} md={4} className="font-weight-bold"><ArrowRightIcon />６月のイベント</Grid>
            <Grid item xs={12} md={8}>
              北奥羽囲碁名人戦　予選会<br/>
              はちのへ将棋まつり
            </Grid>
          </Grid>
          <Divider />
          <Grid className="p-3" spacing={0} container direction="row" justify="center">
            <Grid item xs={12} md={4} className="font-weight-bold"><ArrowRightIcon />７月のイベント</Grid>
            <Grid item xs={12} md={8}>
              県南地区中学校選抜ソフトボール大会<br/>
              県南中学校選抜野球大会<br/>
              久慈地区家庭婦人バレーボール大会<br/>
              デーリー東北カップ八戸港カッターレース
            </Grid>
          </Grid>
          <Divider />
          <Grid className="p-3" spacing={0} container direction="row" justify="center">
            <Grid item xs={12} md={4} className="font-weight-bold"><ArrowRightIcon />８月のイベント</Grid>
            <Grid item xs={12} md={8}>
              八戸納涼盆踊り大会<br/>
              北奥羽団体囲碁大会<br/>
              大学ＯＢ対抗ゴルフ大会<br/>
              リクルートラウンジ八戸
            </Grid>
          </Grid>
          <Divider />
          <Grid className="p-3" spacing={0} container direction="row" justify="center">
            <Grid item xs={12} md={4} className="font-weight-bold"><ArrowRightIcon />９月のイベント</Grid>
            <Grid item xs={12} md={8}>
              北奥羽囲碁名人戦<br/>
              ビブリオバトル　予選会
            </Grid>
          </Grid>
          <Divider />
          <Grid className="p-3" spacing={0} container direction="row" justify="center">
            <Grid item xs={12} md={4} className="font-weight-bold"><ArrowRightIcon />１０月のイベント</Grid>
            <Grid item xs={12} md={8}>
              北奥羽将棋名人戦<br/>
              北奥羽シニア将棋名人戦<br/>
              北奥羽こども将棋大会<br/>
              北奥羽短歌大会<br/>
              八戸リレーマラソン<br/>
              リクルートラウンジ東京
            </Grid>
          </Grid>
          <Divider />
          <Grid className="p-3" spacing={0} container direction="row" justify="center">
            <Grid item xs={12} md={4} className="font-weight-bold"><ArrowRightIcon />１１月のイベント</Grid>
            <Grid item xs={12} md={8}>
              北奥羽俳句大会<br/>
              県南市町村対抗ボウリング大会<br/>
              デーリー東北新聞社旗少年サッカー大会<br/>
              デーリー東北交流カップＵ－１２女子８人制サッカー大会<br/>
              ビブリオバトル　決勝戦<br/>
              職域・愛好団体対抗将棋大会<br/>
              新聞感想文コンクール（表彰式）<br/>
              家庭婦人バレーボール大会
            </Grid>
          </Grid>
          <Divider />
          <Grid className="p-3" spacing={0} container direction="row" justify="center">
            <Grid item xs={12} md={4} className="font-weight-bold"><ArrowRightIcon />１２月のイベント</Grid>
            <Grid item xs={12} md={8}>
              民謡・お笑い夢の祭典
            </Grid>
          </Grid>
        </Box>

        {/* <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            デーリー東北たびーぐ
          </Typography>
          　デーリー東北新聞社１ＦにＪＴＢの窓口ができました。<br/>
          　ＪＴＢの豊富な商品の取り扱いや、独自のツアーも企画運営しています。<br/>
          　お電話での受付もしておりますのでお気軽にお問い合わせください。<br/>
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="https://stores.jtb.co.jp/bp289-0" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  詳　細
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box> */}

      </div>
    </div>
  );
}

export default GuideEvent;
